export const FETCH_USER_REQ = 'FETCH_USER_REQ'
export const FETCH_USER_SUCC = 'FETCH_USER_SUCC'
export const FETCH_USER_ERR = 'FETCH_USER_ERR'
export const RESET_USER = 'RESET_USER'